// Snapshot of the onboarding device panel, attached to the registration
// request as donation_context.extra.device_checks so the pilot audit can
// see what the participant's setup looked like at the moment they started.
let snapshot = {};
export const setDeviceChecksSnapshot = (s) => { snapshot = s || {}; };
export const getDeviceChecksSnapshot = () => ({ ...snapshot, captured_at: new Date().toISOString() });
